import React, { useEffect } from "react"
import { Helmet } from "react-helmet"
import { graphql, useStaticQuery } from "gatsby"
import { SnackbarProvider } from "notistack"
import SWUpdate from "./sw-update"

import {
  createMuiTheme,
  makeStyles,
  createStyles,
  Theme as AugmentedTheme,
  ThemeProvider,
} from '@material-ui/core/styles';

import theme from "../utils/theme"

import "./pmb-layout.css"
import { collectView } from "src/lib/av-restapi"

type SPALayoutProps = {
  children: React.ReactNode
}

export default function SPALayout({ children }: SPALayoutProps) {
  const data = useStaticQuery(graphql`
    query SiteMetaQuery {
      site {
        siteMetadata {
          title
          description
          author
        }
      }
    }
  `)

  const {
    site: {
      siteMetadata: { title, description },
    },
  } = data

  useEffect(() => {
    collectView()
  }, [])

  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider maxSnack={1} dense>
        {/* <Global styles={globalStyles} /> */}
        <Helmet
          title={title}
          meta={[
            { name: "description", content: description },
            // { name: "keywords", content: keywords.join() },
          ]}
        >
          <html lang="zh-CN" />
          <noscript>This site runs best with JavaScript enabled.</noscript>
        </Helmet>

        {children}

        <SWUpdate />
      </SnackbarProvider>
    </ThemeProvider>
  )
}
